export default "__VITE_ASSET__K4EflNTL__"